import { useEffect, useMemo, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresaIndividual } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";

import NotaFiscal from "../../../../lib/json/consultas/NotaFiscal.json"
import SelectEmpresa from "../../../components/Select/Empresa";
import SelectCentroCusto from "../../../components/Select/CentroCusto";
import { ErroMsg, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { format, startOfMonth, startOfYear } from "date-fns";
import { usePopUp } from "../../../components/BootBox";
import { handleData, handleValorTotal } from "../../../components/GridCell/Preco";
import SelectFornecedor from "../../../components/Select/Fornecedor";
import { handleFornecedorNFColumn, handleFilialNotaFiscal, handleStatusNF, handleUsuarioInclusao } from "../../../components/GridCell/NotaFiscal";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import SelectFixo from "../../../components/SelectFixo";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";
import ExportarExcel from "../../../components/ExportarExcel";

function ListaNotaFiscal(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = NotaFiscal.tabelas;
    
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfYearDate = startOfYear(currentDate);
    const firstDayOfMonthDate = startOfMonth(currentDate);
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("notaEmpresa",{value: '', text: ''});
    const [campoPedido, setCampoPedido] = useSessionStorageState("notaPedido",'');
    const [documento, setDocumento] = useSessionStorageState("notaDocumento",'');
    const [dateDe, setDateDe] = useSessionStorageState("notaDateDe",format(firstDayOfYearDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("notaDateAte",format(currentDate, 'yyyy-MM-dd'));
    const [dateDeDigitacao, setDateDeDigitacao] = useSessionStorageState("notaDateDigitacaoDe",format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAteDigitacao, setDateAteDigitacao] = useSessionStorageState("notaDateDigitacaoAte",format(currentDate, 'yyyy-MM-dd'));
    const [campoFornecedor, setCampoFornecedor] = useSessionStorageState("notaFornecedor",null);
    const [campoCentroCusto, setCampoCentroCusto] = useSessionStorageState("notaCentroCusto",null);    
    const [campoStatus, setCampoStatus] = useSessionStorageState("notaCampoStatus",{value: "0", text: "Todos", filtroSQL: "( 1 = 1 )"});    
    
    const options = [
        {
            value: '0',
            text: "Todos",
            filtroSQL: "( 1 = 1 )"
        },
        {
            value: '1',
            text: "Rejeitado",
            filtroSQL: "( F1_STATUS = 'R' )"
        },
        {
            value: '2',
            text: "Em Aprovação",
            filtroSQL: "( F1_STATUS = 'B' AND F1_APROV = '" + window._env_?.REACT_APP_APROVA_NF + "' )"
        },
        {
            value: '5',
            text: "Bloqueado por Tolerância",
            filtroSQL: "( F1_STATUS = 'B' AND F1_APROV != '" + window._env_?.REACT_APP_APROVA_NF + "' )"
        },
        {
            value: '3',
            text: "Pré Nota",
            filtroSQL: "( F1_STATUS = '' AND D1_TES = '' )"
        },
        {
            value: '4',
            text: "Nota Fiscal Classificada",
            filtroSQL: "( F1_STATUS NOT IN ('R','B') AND D1_TES != '' )"
        },
        {
            value: '5',
            text: "Nota Fiscal Excluídas",
        },

    ]

    const excelColumns = [
        {
            Header: 'Filial',
            accessor: "F1_FILIAL",
        },
        {
            Header: 'Documento',
            accessor: "F1_DOC",
        },
        {
            Header: 'Serie',
            accessor: "F1_SERIE",
        },
        {
            Header: 'Fornecedor',
            accessor: "F1_FORNECE",            
        },
        {
            Header: 'Loja Fornecedor',
            accessor: "F1_FORNECE",            
        },
        {
            Header: 'Nome Fornecedor',
            accessor: "A2_NOME",            
        },
        {
            Header: 'Emissão',
            accessor: 'F1_EMISSAO',
            Cell: handleData
        },
        {
            Header: 'Digitação',
            accessor: 'INCLUSAO',
            Cell: handleData
        },
        {
            Header: 'Valor',
            accessor: 'TOTAL',
            Cell: handleValorTotal
        },
        {
            Header: 'Status',
            accessor: 'TIPO_DOC',
            Cell: handleStatusNF
        },
        {
            Header: 'Usuário Inclusão',
            accessor: 'USRINC',
            Cell: handleUsuarioInclusao
        }
    ];
    
    // Colunas do grid
    const columns = [
        {
            Header: 'Filial',
            accessor: "F1_FILIAL",
            Cell: (item) => handleFilialNotaFiscal(item, DisparaBootBox, FechaBootBox, navigate),
        },
        {
            Header: 'Fornecedor',
            accessor: "F1_FORNECE",
            Cell: handleFornecedorNFColumn
        },
        {
            Header: 'Emissão',
            accessor: 'F1_EMISSAO',
            Cell: handleData
        },
        {
            Header: 'Digitação',
            accessor: 'INCLUSAO',
            Cell: handleData
        },
        {
            Header: 'Valor',
            accessor: 'TOTAL',
            Cell: handleValorTotal
        },
        {
            Header: 'Status',
            accessor: 'TIPO_DOC',
            Cell: (item) => { 
                const { F1_APROV, F1_STATUS } = item.row.original
                const aprovFiscal = window._env_?.REACT_APP_APROVA_NF

                return (
                    <>
                        {F1_STATUS === 'B' && F1_APROV !== aprovFiscal && 'Bloqueado por Tolerância'}
                        { ( (F1_STATUS === 'B' && F1_APROV === aprovFiscal) || F1_STATUS !== 'B' ) && item.value }
                    </>
                )
            }
        },
    ];

    // WHERE/filtros da consulta do grid
    const retornaConsultaDefault = () => {
        let consultaDefault = NotaFiscal.consulta;
        let consultaFiltro = ' ';
        
        consultaFiltro += "AND F1_FILIAL = FILIAL(SF1) ";
        
        if(documento) {
            consultaFiltro += "AND F1_DOC = '"+documento+"' ";
        }
        if(dateDe) {
            consultaFiltro += "AND F1_EMISSAO >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            consultaFiltro += "AND F1_EMISSAO <= '"+dateAte.replaceAll('-','')+"' ";
        }
        if(dateDeDigitacao) {
            consultaFiltro += "AND CASE WHEN SUBSTRING(F1_USERLGI,3,1) != ' '  THEN DATEADD(DAY, CAST( CONCAT((ASCII(SUBSTRING(F1_USERLGI,12,1)) - 50),ASCII(SUBSTRING(F1_USERLGI,16,1)) - 50) + IIF(SUBSTRING(F1_USERLGI,8,1) != '<', 1000, 1 ) AS INT), CASE WHEN SUBSTRING(F1_USERLGI,8,1) IN ('=','<') THEN '20230519' ELSE '19960101' END) ELSE NULL END >= '"+dateDeDigitacao.replaceAll('-','')+"' ";
        }
        if(dateAteDigitacao) {
            consultaFiltro += "AND CASE WHEN SUBSTRING(F1_USERLGI,3,1) != ' '  THEN DATEADD(DAY, CAST( CONCAT((ASCII(SUBSTRING(F1_USERLGI,12,1)) - 50),ASCII(SUBSTRING(F1_USERLGI,16,1)) - 50) + IIF(SUBSTRING(F1_USERLGI,8,1) != '<', 1000, 1 ) AS INT), CASE WHEN SUBSTRING(F1_USERLGI,8,1) IN ('=','<') THEN '20230519' ELSE '19960101' END) ELSE NULL END <= '"+dateAteDigitacao.replaceAll('-','')+"' ";
        }
        if(campoFornecedor?.value) {
            consultaFiltro += "AND F1_FORNECE + F1_LOJA = '"+campoFornecedor.value+"' ";
        }
        if(campoCentroCusto?.value) {
            consultaFiltro += "AND F1_FILIAL + F1_DOC + F1_SERIE + F1_FORNECE + F1_LOJA IN (SELECT DISTINCT D1A.D1_FILIAL + D1A.D1_DOC + D1A.D1_SERIE + D1A.D1_FORNECE + D1A.D1_LOJA FROM TABELA(SD1) D1A WHERE D1A.D_E_L_E_T_ <> '*' AND D1A.D1_FILIAL = FILIAL(SD1) AND D1A.D1_CC = '"+campoCentroCusto.value+"')  ";
        }
        if(campoPedido) {
            consultaFiltro += "AND F1_FILIAL + F1_DOC + F1_SERIE + F1_FORNECE + F1_LOJA IN (SELECT DISTINCT D1A.D1_FILIAL + D1A.D1_DOC + D1A.D1_SERIE + D1A.D1_FORNECE + D1A.D1_LOJA FROM TABELA(SD1) D1A WHERE D1A.D_E_L_E_T_ <> '*' AND D1A.D1_FILIAL = FILIAL(SD1) AND D1A.D1_PEDIDO = '"+campoPedido+"')  ";
        }
        if(campoStatus?.value) {
            if (campoStatus.value == "5"){
                consultaDefault = consultaDefault.replace("D_E_L_E_T_ <> '*'", "D_E_L_E_T_ = '*'")
                consultaDefault = consultaDefault.replace("D_E_L_E_T_ != '*'", "D_E_L_E_T_ = '*'")
                consultaFiltro = "AND ( F1_STATUS = 'R' ) "
            }else{
                consultaFiltro += "AND "+campoStatus.filtroSQL+" ";
            }
        }
        
        return consultaDefault.replace('FILTRO', consultaFiltro)
    }

    // Processa consulta do grid
    const listaNF = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );
        setData(retConsulta.data);
        setCarregar(false);
    }

    useEffect( () => {
        listaNF()
    },[])

    const handleAlterar = (row) =>{
        const {EMPRESA, F1_FILIAL, F1_DOC, F1_SERIE, F1_FORNECE, F1_LOJA} = row.original

        navigate(`./Alterar/${F1_DOC}${F1_SERIE}${F1_FORNECE}${F1_LOJA}/${EMPRESA}${F1_FILIAL}`)
    }
    
    const handleVisualizar = (row) =>{
        const {EMPRESA, F1_FILIAL, F1_DOC, F1_SERIE, F1_FORNECE, F1_LOJA} = row.original

        navigate(`./Visualizar/${F1_DOC}${F1_SERIE}${F1_FORNECE}${F1_LOJA}/${EMPRESA}${F1_FILIAL}`)
    }

    const handleExcluir = async (row) => {
        const {EMPRESA, F1_FILIAL, F1_DOC, F1_SERIE, F1_FORNECE, F1_LOJA, A2_NOME} = row.original
        
        const idRow = EMPRESA + '' + F1_FILIAL + '|' + F1_DOC + '|' + F1_SERIE + '|' + F1_FORNECE + '/' + F1_LOJA;
        
        const Mensagem = `Tem certeza que deseja excluir a Nota Fiscal ${F1_DOC + ' - ' + F1_SERIE + '</br> Fornecedor: ' + F1_FORNECE + '/' + F1_LOJA + ' - ' + A2_NOME + ' / Filial: ' + F1_FILIAL}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { 
            Numero: row.split('|')[1],
            Serie: row.split('|')[2],
            Fornecedor: row.split('|')[3], 
        }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('EXCLUIRNOTAFISCAL', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
                listaNF();
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    };

    const handleDocumento = () => {
        const value = documento.trim() ? documento.trim().padStart(9, '0'): "";
        
        setDocumento(value);
    }

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Nota Fiscal"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                <Col md="8" xs="12">
                    <SelectFornecedor
                        campoFornecedor={campoFornecedor}
                        changeFornecedor={setCampoFornecedor}
                        empresaLogada={empresa.value}
                    />
                </Col>
            </Row>
            <Row>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Pedido"
                        tipo='text'
                        max="9"
                        value={campoPedido}  // Define o valor do campo com base no estado
                        onChange={(e) => setCampoPedido(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Documento"
                        tipo='text'
                        max="9"
                        value={documento}  // Define o valor do campo com base no estado
                        handleBlur={handleDocumento}
                        onChange={(e) => setDocumento(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Digitação de"
                        tipo='date'
                        value={dateDeDigitacao}
                        onChange={(e) => setDateDeDigitacao(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Digitação até"
                        tipo='date'
                        value={dateAteDigitacao}
                        onChange={(e) => setDateAteDigitacao(e.target.value)}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectCentroCusto 
                        campoCentroCusto={campoCentroCusto}
                        changeCentroCusto={setCampoCentroCusto}
                        empresaLogada={empresa.value}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectFixo 
                        options={options} 
                        value={campoStatus} 
                        selectedOptionValue={campoStatus}
                        isLabel={true} 
                        label="Status" 
                        onChange={(e) => setCampoStatus(e)}
                    />
                </Col>
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaNF}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="Nota_Fiscal"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote", regraExclude: "( row.original.F1_STATUS.trim() !== 'B' ) "}, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger", regraExclude: "( row.original.F1_STATUS.trim() !== 'B'  ) "}, 
                        ]}
                        paginacao={100}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaNotaFiscal;